import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('accountWorkspace');

    return {
        ACCOUNT: t('account'),
        ACCOUNT_SUBTITLE: t('accountSubtitle'),
        CERTIFICATIONS: t('certifications'),
        CERTIFICATIONS_SUBTITLE: t('certificationsSubtitle'),
        DETAILS: t('details'),
        EDIT: t('edit'),
        EMAIL: t('email'),
        FIRST_NAME: t('firstName'),
        LAST_NAME: t('lastName'),
        MY_INFORMATION: t('myInformation'),
        NOT_PROVIDED: t('notProvided'),
        PHONE: t('phone'),
        ROLES: t('roles')
    };
};

export default useTranslation;
